var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { hide: _vm.loading },
    },
    [
      _c("cms-heading", { attrs: { title: _vm.pageTitle } }),
      _c(
        "cms-form-panel",
        {
          attrs: {
            "submit-button": "Opslaan",
            "cancel-button": true,
            submitting: _vm.submitting,
          },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Titel",
              name: "title",
              "data-vv-as": "Titel",
              error: _vm.error("title"),
            },
            model: {
              value: _vm.pendingLoggerType.title,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLoggerType,
                  "title",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLoggerType.title",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              step: "any",
              min: "0",
              title: "Loggerkosten",
              hint: "Per maand",
              name: "loggerPrice",
              "data-vv-as": "Loggerkosten",
              error: _vm.error("loggerPrice"),
            },
            model: {
              value: _vm.pendingLoggerType.loggerPrice,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLoggerType,
                  "loggerPrice",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLoggerType.loggerPrice",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              step: "any",
              min: "0",
              title: "Storingskosten",
              hint: "Per maand",
              name: "failurePrice",
              "data-vv-as": "Storingskosten",
              error: _vm.error("failurePrice"),
            },
            model: {
              value: _vm.pendingLoggerType.failurePrice,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLoggerType,
                  "failurePrice",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLoggerType.failurePrice",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              step: "any",
              min: "0",
              title: "Portalkosten",
              hint: "Per maand",
              name: "usagePrice",
              "data-vv-as": "Portalkosten",
              error: _vm.error("usagePrice"),
            },
            model: {
              value: _vm.pendingLoggerType.usagePrice,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLoggerType,
                  "usagePrice",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLoggerType.usagePrice",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              step: "any",
              min: "0",
              title: "Backoffice kosten",
              hint: "Per maand",
              name: "backofficePrice",
              "data-vv-as": "Backoffice kosten",
              error: _vm.error("backofficePrice"),
            },
            model: {
              value: _vm.pendingLoggerType.backofficePrice,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLoggerType,
                  "backofficePrice",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLoggerType.backofficePrice",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              step: "any",
              min: "0",
              title: "Handmeetrondekosten",
              hint: "Per maand",
              name: "manualRoundPrice",
              "data-vv-as": "Handmeetrondekosten",
              error: _vm.error("manualRoundPrice"),
            },
            model: {
              value: _vm.pendingLoggerType.manualRoundPrice,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLoggerType,
                  "manualRoundPrice",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLoggerType.manualRoundPrice",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }